module.exports = __webpack_public_path__ + "static/media/elg.995e0446.png";